export const OUTCOMES_GET_BY_CLIENT_AND_PROGRAM = 'OUTCOMES_GET_BY_CLIENT_AND_PROGRAM';
export const OUTCOMES_GET_BY_CLIENT_AND_PROGRAM_SUCCESS =
  'OUTCOMES_GET_BY_CLIENT_AND_PROGRAM_SUCCESS';
export const OUTCOMES_SAVE = 'OUTCOMES_SAVE';
export const OUTCOMES_ERROR = 'OUTCOMES_ERROR';
